import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="mt-20 border-t border-[hsla(38,25%,80%,0.6)] px-5 py-10 lg:px-8"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
        <p className="font-serif-display text-2xl text-foreground">Call God</p>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
          <Link
            to="/history"
            data-testid="footer-history-link"
            className="transition-colors hover:text-foreground"
          >
            History
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="transition-colors hover:text-foreground"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="transition-colors hover:text-foreground"
          >
            Terms
          </Link>
          <a
            href="tel:+15822580456"
            data-testid="footer-call-link"
            className="transition-colors hover:text-foreground"
          >
            +1 (582) 258-0456
          </a>
        </nav>
      </div>

      <div className="mx-auto mt-6 flex max-w-6xl items-center justify-end">
        <p className="text-[12px] leading-5 text-muted-foreground">
          © {new Date().getFullYear()} Call God
        </p>
      </div>
    </footer>
  );
};

export default Footer;
